import {
  ChatSharedLinksApi,
  Configuration,
  type ResponseChatSharedLinkArray,
} from '@/infrastructure/api/client_typescript';
import type { AxiosResponse } from 'axios';
import { TokenStore } from '@/infrastructure/storage/TokenStore';

export class SharedLinkService {
  private sharedLinksApi: ChatSharedLinksApi;

  constructor(apiBaseUrl: string, tokenStore: TokenStore) {
    const config = new Configuration({
      basePath: apiBaseUrl,
      accessToken: () => tokenStore.getAccess() || '',
    });
    this.sharedLinksApi = new ChatSharedLinksApi(config);
  }

  async createSharedLink(chatId: string): Promise<string> {
    const response = await this.sharedLinksApi.createChatSharedLink(chatId);
    return response.data.id;
  }

  async deleteSharedLink(chatId: string, sharedLinkId: string): Promise<void> {
    await this.sharedLinksApi.deleteChatSharedLink(chatId, sharedLinkId);
  }

  async getSharedLink(chatId: string): Promise<string | null> {
    try {
      const raw = await this.sharedLinksApi.listChatSharedLinks(chatId);
      const response =
        raw as unknown as AxiosResponse<ResponseChatSharedLinkArray>;
      const links = response.data.shared_links;

      if (Array.isArray(links) && links.length > 0) {
        return links[0].id;
      }

      return null;
    } catch (err: unknown) {
      const error = err as { response?: { status?: number } };
      if (error.response?.status === 404) return null;
      throw error;
    }
  }
}
